export const SET_CART_LIST = "SET_CART_LIST";
export const SET_CART_CLEAR = "SET_CART_CLEAR";












